import styled from "styled-components";
import {MobileCalVW, TabletCalVW} from "@utils/CalVW.tsx";
import {media} from "@/styles/Qtheme.ts";

export const AccountSecurityListSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const AccountSecurityListItemSection = styled.div`
	display: flex;
	align-self: center;
	justify-content: space-between;
	flex-direction: row;
	width: 95%;
	padding: 20px 0;
    
    @media ${media.desktop} {
        flex-direction: column;
    }

    @media ${media.mobile} {
        padding: ${MobileCalVW(16)};
    }
    
	@media only screen and (max-width: 970px) {
		flex-direction: column;
	}
`
export const InfoLeftLists = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
    width: 85%;
`
